<div id="team" class="team bg-light mt-5 py-5">
    <div class="container">
        <div class="row mt-3">
            <div class="col-12">
                <h1 class="fw-bold title ps-3 display-5">Team</h1>
            </div>
        </div>
    </div>
    <div class="container mt-5">
        <div class="row mb-5 team" *ngFor="let items of peoples">
            <div class="col-12">
                <div
                    class="fs-2 border-bottom border-danger border-3 fw-bold mb-3 px-0 py-1 team-title">
                    <i class="bi bi-award-fill me-1"></i>
                    {{items.title}}
                    <span class="fs-4 fw-normal ms-2 text-secondary">{{items.sub_title}}</span>
                    <span class="fs-4 fw-normal text-secondary"
                        *ngIf="items.students.length>1">s</span>
                </div>
            </div>
            <div class="col-12">
                <div class="container px-0">
                    <div class="row justify-content-center align-items-center student mb-3"
                        *ngFor="let student of items.students"
                        [ngClass]="{'alumni-row': items.type === 'alumnus'}">
                        <ng-container *ngIf="items.type !== 'alumnus'">
                            <div class="col-12 col-sm-3 col-md-3 col-lg-2">
                                <img [src]="'../../assets/img/people/'+student.photo"
                                    class="rounded photo img-fluid" [attr.alt]="student.fullname">
                            </div>
                            <div class="col-12 col-sm col-md col-lg mt-4">
                                <h5 class="text-secondary fs-4 fullname">{{student.fullname}}
                                </h5>
                                <p class="text-secondary mt-3 desc" *ngFor="let desc of student.descs">
                                    {{desc}}</p>
                            </div>
                        </ng-container>
                        
                        <ng-container *ngIf="items.type === 'alumnus'">
                            <div class="col-12 col-sm-4 col-md-4 col-lg-3">
                                <h5 class="text-secondary fs-4 fullname">{{student.fullname}}</h5>
                            </div>
                            <div class="col-12 col-sm col-md col-lg">
                                <p class="text-secondary desc" *ngFor="let desc of student.descs">{{desc}}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
